<template lang="pug">

  transition( 
    @enter="enter"
    @leave="leave"
    appear 
  )

    button(
      @mouseenter="onMouseEnter"
      @touchstart="onTouchStart"
      @focus="onMouseEnter"
      @mouseleave="onMouseLeave"
      @touchend="onTouchEnd"
      @blur="onMouseLeave"
      @click="onClick"
      :class="{ 'white' : isWhite }"
      :aria-label="lang_en['home-aria-label-button-close-overlay']" 
      ).close-btn
        .bg(ref="bg")
        .inner(ref="inner")
          close-svg( ref="close" v-show="showClose" )



</template>

<script>

import gsap from 'gsap' 
import Env from 'src/config/env'
import { mapState, mapMutations } from 'vuex'
import { MODAL_STATES, PATHS } from 'src/config/app'
import CloseSvg from '@/components/common/CloseSvg'

export default {

  props: {
    theme: String
  },

  data() {
    return { 
      showClose: false
    }
  },

  mounted(){ },

  computed: {
    isWhite(){
      return this.theme === 'white'
    },

    ...mapState('app', [
      'reduced_motion'
    ]),
  },

  components: {
    CloseSvg
  },

  methods: {

    // ...mapMutations('app',[ 'setModalState']),

    onClick(){
      this.$emit('click')
    },

    onMouseEnter( ){  

      if(Env.touch_device){
        return 
      }

      this.mouseenter()
    },

    onMouseLeave( ){ 
      
      if(Env.touch_device){
        return 
      }

      this.mouseleave()
    },

    onTouchStart(){
      this.mouseenter()
    },

    onTouchEnd(){
      this.mouseleave()
    },

    mouseenter(){  
      gsap.killTweensOf([this.$refs.bg, this.$refs.inner])
      this.$refs.close.mouseenter()
      gsap.to(this.$refs.bg, { duration: 0.3 * this.motion_clamp, opacity: 1, scale: 1, ease: 'expo.inOut' })  
      gsap.to(this.$refs.inner, { duration: 0.3 * this.motion_clamp, scale: 0.7, ease: 'expo.inOut' }) 
    },

    mouseleave(){
      gsap.killTweensOf([this.$refs.bg, this.$refs.inner])
      this.$refs.close.mouseleave() 
      gsap.to(this.$refs.bg, { duration: 0.3 * this.motion_clamp, opacity: 0, scale: 0.8, ease: 'expo.inOut' })  
      gsap.to(this.$refs.inner, { duration: 0.3 * this.motion_clamp, scale: 1, ease: 'expo.inOut' })  
    },

    enter( el, done ){ 

      done()

      this.showClose = true
 
      this.$nextTick(()=>{ this.$el.focus() }) 
    },

    leave( el, done ){ 
      done()  
    },

  }
}

</script>

<style lang="sass">
@import "src/styles/common.sass"


.close-btn
  position: relative
  width: 44px
  height: 44px
  display: flex
  align-items: center
  justify-content: center
  outline: none 

  .bg
    transform: scale(0.8)
    background: #282C68
    border-radius: 50%
    opacity: 0
    position: absolute
    top: 0
    height: 100%
    width: 100%

  &.white
    svg
      .stroke-one,
      .stroke-two
        stroke: white

  svg
    position: relative
    display: block
    width: 20px
    height: 20px
    overflow: visible

    .stroke-one
      stroke: #282C68
    .stroke-two
      stroke: #373C85
</style>
